module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/6@2x_98b82ec766cd959850db14a00b67590d.png";